// Brand configuration for multi-domain support
// Detects the current brand based on hostname

const brands = {
  forening: {
    id: 'forening',
    name: 'Foreningsbogføring',
    domain: 'foreningsbogfoering.dk',
    fullName: 'Foreningsbogføring.dk',
    initials: 'FB',
    logoIcon: 'FB',
    supportEmail: 'support@foreningsbogfoering.dk',
    primaryColor: '#1a56db',
    primaryLight: '#2563eb',
    primaryDark: '#1e3a5f',
    accentColor: '#2563eb',
    cssClass: 'brand-forening',
    meta: {
      title: 'Foreningsbogføring.dk - Nemt regnskab for foreninger',
      description: 'Foreningsbogføring.dk - Det nemme og billige regnskabssystem til danske foreninger. Kun 99 kr/md.'
    },
    landing: {
      heroBadge: 'Nyt i 2026 — Prøv 1 måned gratis',
      heroTitle: 'Regnskab for foreninger',
      heroTitleHighlight: 'der bare virker',
      heroDescription: 'Foreningsbogføring er det nemme og billige regnskabssystem bygget til danske foreninger. Bogfør på under et minut — uden regnskabserfaring.',
      ctaPrimary: 'Opret forening gratis',
      proofText: 'Bygget til danske foreninger — med Erhvervsstyrelsens standardkontoplan',
      featuresTitle: 'Alt hvad din forening behøver',
      featuresSubtitle: 'Et komplet regnskabssystem designet specifikt til foreningers behov — ikke et tilpasset virksomhedssystem.',
      features: [
        { icon: '📚', title: 'Nem bogføring', desc: 'Hurtig bogføring med færdige skabeloner. Vælg type, indtast beløb — færdig.' },
        { icon: '📊', title: 'Resultat & balance', desc: 'Automatisk resultatopgørelse og balance. Altid overblik over foreningens økonomi.' },
        { icon: '👥', title: 'Medlemskartotek', desc: 'Hold styr på alle medlemmer med kontaktinfo, indmeldingsdato og status.' },
        { icon: '📅', title: 'Aktiviteter', desc: 'Opret aktiviteter og holdøvelser. Track tilmeldinger og deltagelse.' },
        { icon: '📄', title: 'Bilag & kvitteringer', desc: 'Upload kvitteringer og bilag direkte. Alt samlet ét sted, klar til revisor.' },
        { icon: '🔒', title: 'Sikkerhed & revision', desc: 'Fuld ændringslog og brugerroller. Gennemsigtighed for bestyrelse og medlemmer.' }
      ],
      howSteps: [
        { title: 'Opret forening', desc: 'Tilmeld dig gratis og opret din forening med navn og CVR-nr.' },
        { title: 'Inviter kassereren', desc: 'Tilføj brugere og tildel roller til bestyrelsen.' },
        { title: 'Begynd at bogføre', desc: 'Brug hurtig bogføring eller opret bilag manuelt. Færdig!' }
      ],
      faqs: [
        { q: 'Hvem er Foreningsbogføring til?', a: 'Foreningsbogføring er designet til små og mellemstore foreninger — idrætsklubber, grundejerforeninger, kulturforeninger, spejdergrupper og alle andre frivillige organisationer der har brug for et simpelt regnskabssystem.' },
        { q: 'Skal man være revisor for at bruge det?', a: 'Absolut ikke! Systemet er bygget så kasseren nemt kan bogføre uden regnskabserfaring. Vælg en skabelon, indtast beløbet, og systemet klarer resten.' },
        { q: 'Kan jeg prøve det gratis?', a: 'Ja! Oprettelse er gratis og den første måned er helt gratis. Ingen kreditkort påkrævet.' },
        { q: 'Kan flere personer have adgang?', a: 'Ja, I kan oprette flere brugere med forskellige roller. Kassereren kan bogføre, mens bestyrelsen kan se rapporter.' },
        { q: 'Følger kontoplanen dansk standard?', a: 'Ja, vi følger Erhvervsstyrelsens officielle standardkontoplan, tilpasset specifikt til foreninger.' },
        { q: 'Kan jeg importere data fra Excel?', a: 'Ja, du kan importere både kontoplan, medlemmer og posteringer direkte fra Excel-filer.' }
      ],
      ctaTitle: 'Klar til at forenkle foreningens regnskab?',
      ctaSubtitle: 'Opret dig gratis i dag og få 1 måneds gratis adgang. Ingen binding.',
      footerDescription: 'Det nemme og billige regnskabssystem til danske foreninger.',
      mockupTitle: 'Oversigt — Foreningsbogføring'
    },
    register: {
      title: 'Opret din forening',
      subtitle: 'Gratis oprettelse — 1 måneds gratis prøveperiode',
      step1Label: 'Forening',
      orgNameLabel: 'Foreningsnavn',
      orgNamePlaceholder: 'F.eks. Haarby Pensionistforening',
      submitButton: 'Opret forening gratis',
      ctaFooter: 'Opret forening'
    }
  },
  holding: {
    id: 'holding',
    name: 'Holdingregnskab',
    domain: 'holdingregnskab.dk',
    fullName: 'Holdingregnskab.dk',
    initials: 'HR',
    logoIcon: 'HR',
    supportEmail: 'support@holdingregnskab.dk',
    primaryColor: '#0d6e3f',
    primaryLight: '#15803d',
    primaryDark: '#14532d',
    accentColor: '#16a34a',
    cssClass: 'brand-holding',
    meta: {
      title: 'Holdingregnskab.dk - Nemt regnskab for holdingselskaber',
      description: 'Holdingregnskab.dk - Det nemme og billige regnskabssystem til danske holdingselskaber. Kun 99 kr/md.'
    },
    landing: {
      heroBadge: 'Nyt i 2026 — Prøv 1 måned gratis',
      heroTitle: 'Regnskab for holdingselskaber',
      heroTitleHighlight: 'der bare virker',
      heroDescription: 'Holdingregnskab er det nemme og billige regnskabssystem bygget til danske holdingselskaber. Bogfør på under et minut — uden regnskabserfaring.',
      ctaPrimary: 'Opret selskab gratis',
      proofText: 'Bygget til danske holdingselskaber — med Erhvervsstyrelsens standardkontoplan',
      featuresTitle: 'Alt hvad dit holdingselskab behøver',
      featuresSubtitle: 'Et komplet regnskabssystem designet specifikt til holdingselskaber — enkelt, overskueligt og lovmedholdeligt.',
      features: [
        { icon: '📚', title: 'Nem bogføring', desc: 'Hurtig bogføring med færdige skabeloner. Vælg type, indtast beløb — færdig.' },
        { icon: '📊', title: 'Resultat & balance', desc: 'Automatisk resultatopgørelse og balance. Altid overblik over selskabets økonomi.' },
        { icon: '🏢', title: 'Selskabsoversigt', desc: 'Styr dine datterselskaber og investeringer med fuldt overblik.' },
        { icon: '📄', title: 'Bilag & kvitteringer', desc: 'Upload kvitteringer og bilag direkte. Alt samlet ét sted, klar til revisor.' },
        { icon: '💰', title: 'Fakturering', desc: 'Opret og send fakturaer. Hold styr på tilgodehavender og betalinger.' },
        { icon: '🔒', title: 'Sikkerhed & revision', desc: 'Fuld ændringslog og brugerroller. Overholdelse af bogføringsloven.' }
      ],
      howSteps: [
        { title: 'Opret selskab', desc: 'Tilmeld dig gratis og opret dit holdingselskab med navn og CVR-nr.' },
        { title: 'Inviter bogholder', desc: 'Tilføj brugere og tildel roller til relevante medarbejdere.' },
        { title: 'Begynd at bogføre', desc: 'Brug hurtig bogføring eller opret bilag manuelt. Færdig!' }
      ],
      faqs: [
        { q: 'Hvem er Holdingregnskab til?', a: 'Holdingregnskab er designet til danske holdingselskaber, ApS og andre mindre selskaber der har brug for et simpelt og overskueligt regnskabssystem.' },
        { q: 'Skal man være revisor for at bruge det?', a: 'Absolut ikke! Systemet er bygget så du nemt kan bogføre uden regnskabserfaring. Vælg en skabelon, indtast beløbet, og systemet klarer resten.' },
        { q: 'Kan jeg prøve det gratis?', a: 'Ja! Oprettelse er gratis og den første måned er helt gratis. Ingen kreditkort påkrævet.' },
        { q: 'Kan flere personer have adgang?', a: 'Ja, du kan oprette flere brugere med forskellige roller. Bogholderen kan bogføre, mens direktionen kan se rapporter.' },
        { q: 'Følger kontoplanen dansk standard?', a: 'Ja, vi følger Erhvervsstyrelsens officielle standardkontoplan.' },
        { q: 'Kan jeg importere data fra Excel?', a: 'Ja, du kan importere både kontoplan og posteringer direkte fra Excel-filer.' }
      ],
      ctaTitle: 'Klar til at forenkle selskabets regnskab?',
      ctaSubtitle: 'Opret dig gratis i dag og få 1 måneds gratis adgang. Ingen binding.',
      footerDescription: 'Det nemme og billige regnskabssystem til danske holdingselskaber.',
      mockupTitle: 'Oversigt — Holdingregnskab'
    },
    register: {
      title: 'Opret dit selskab',
      subtitle: 'Gratis oprettelse — 1 måneds gratis prøveperiode',
      step1Label: 'Selskab',
      orgNameLabel: 'Selskabsnavn',
      orgNamePlaceholder: 'F.eks. Hansen Holding ApS',
      submitButton: 'Opret selskab gratis',
      ctaFooter: 'Opret selskab'
    }
  }
};

function detectBrand() {
  const hostname = window.location.hostname;

  if (hostname.includes('holdingregnskab')) {
    return brands.holding;
  }

  // Check for query param override in development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    const params = new URLSearchParams(window.location.search);
    const brandParam = params.get('brand');
    if (brandParam === 'holding') return brands.holding;
  }

  // Default to forening
  return brands.forening;
}

export const brand = detectBrand();
export { brands };
export default brand;
